import React from 'react';
import { ShoppingCart, User, Menu } from 'lucide-react';
export function Header() {
  return <header className="border-b border-gray-200 bg-white sticky top-0 z-50" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-15">
        {/* Mobile menu button */}
        <div className="flex items-center md:hidden" data-id="element-16">
          <button className="text-gray-900 p-2" data-id="element-17">
            <Menu className="w-6 h-6" data-id="element-18" />
          </button>
        </div>

        {/* Logo */}
        <div className="flex-shrink-0 flex items-center justify-center md:justify-start flex-1 md:flex-none" data-id="element-19">
          <span className="font-bold text-2xl tracking-tighter text-[#4A2B4D]" data-id="element-20"></span>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-21">
          <a href="#" className="text-gray-900 hover:text-gray-600 text-sm font-medium" data-id="element-22">
            La Guía
          </a>
          <a href="#" className="text-gray-900 hover:text-gray-600 text-sm font-medium" data-id="element-23">
            Bonos
          </a>
          <a href="#" className="text-gray-900 hover:text-gray-600 text-sm font-medium" data-id="element-24">
            Testimonios
          </a>
          <a href="#" className="text-gray-900 hover:text-gray-600 text-sm font-medium" data-id="element-25">
            FAQ
          </a>
        </nav>

        {/* Icons */}
        <div className="flex items-center space-x-4" data-id="element-26">
          <button className="text-gray-900 hover:text-gray-600 p-2 hidden sm:block" data-id="element-27">
            <User className="w-5 h-5" data-id="element-28" />
          </button>
          <button className="text-gray-900 hover:text-gray-600 p-2 relative" data-id="element-29">
            <ShoppingCart className="w-5 h-5" data-id="element-30" />
            <span className="absolute top-0 right-0 inline-flex items-center justify-center px-1.5 py-0.5 text-xs font-bold leading-none text-white transform translate-x-1/4 -translate-y-1/4 bg-red-600 rounded-full" data-id="element-31">
              0
            </span>
          </button>
        </div>
      </div>
    </header>;
}